import React from "react";

import ViewAppBar from "../views/ViewAppBar";

import styled from "styled-components";

import ViewFooter from "../views/ViewFooter";

import ViewGerenciarModeloMensagens from "../views/ViewGerenciarModeloMensagens";

import { usePermissao } from "../uteis/permissaoAdm/usePermissao"; 

const ContainerComponente = styled.div`
  display: grid;
  grid-template: 100px 75vh 90rem 170rem 20rem / 100vw;
  @media (min-width: 1100px) {
    grid-template: 100px 100vh 20rem / 100vw;
  }
`;

const GerenciarModeloMensagens: React.FC = () => {

     const { isLoading, isValid } = usePermissao("ADM");
      
        if (isLoading) return <p>Verificando permissão...</p>;
        if (!isValid) return null;

    return(
      <ContainerComponente>
    <ViewAppBar />
    <ViewGerenciarModeloMensagens />
    <ViewFooter />
  </ContainerComponente>
    );
  
  
};
export default GerenciarModeloMensagens;
